import { CircleDot } from "lucide-react";
import { screenshots } from "../assets/screenshots";
import { DeviceMockup } from "../components/DeviceMockup";
import type { LandingContent } from "../content/types";

type VideoRecordingSectionProps = {
  content: LandingContent["video"];
};

export function VideoRecordingSection({ content }: VideoRecordingSectionProps) {
  return (
    <section className="section-pad">
      <div className="site-container split-grid split-reverse">
        <div className="device-stage">
          <DeviceMockup src={screenshots.video} alt="Prismark video recording interface" />
        </div>
        <div className="section-copy">
          <h2>{content.title}</h2>
          <p>{content.body}</p>
          <ul className="check-list">
            {content.points.map((point) => (
              <li key={point}>
                <CircleDot size={17} aria-hidden="true" />
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
